import { render, staticRenderFns } from "./ActionCenterResolveActionItemDialog.vue?vue&type=template&id=dfcb0684&scoped=true&"
import script from "./ActionCenterResolveActionItemDialog.vue?vue&type=script&lang=js&"
export * from "./ActionCenterResolveActionItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./ActionCenterResolveActionItemDialog.vue?vue&type=style&index=0&id=dfcb0684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcb0684",
  null
  
)

export default component.exports